export { default } from "./bookingRemark.api"
